import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLink: '/'
    };
  }
  setSelectedLink(route) {
    // debugger;
    this.setState({ selectedLink: route.link });
  }
  makeLink(route, subRoute) {
    const myClass = subRoute === undefined ? 'link' : 'link link--light';
    const txt = subRoute === undefined ? route.link : subRoute.link;
    return (
      <NavLink
        activeClassName={!subRoute ? 'link--selected' : 'link--active'}
        to={this.props.getPathToLink(route, subRoute)}
        className={`${txt.toLowerCase()} ${myClass}`}
        exact={route.path === '/'}
        strict={route.path === '/'}
      >
        {txt}
      </NavLink>
    );
  }

  render() {
    const { routes, hideSubRoutes, hidden } = this.props;
    return (
      <header className={hidden ? 'hidden' : ''}>
        <ul className="menu menu--header">
          <li className="row row--middle row--no-margins">
            {routes &&
              routes.length > 0 &&
              routes.map((route, i) => (
                <div key={i}>
                  {this.makeLink(route)}
                  {!hideSubRoutes &&
                    route.sublinks &&
                    route.sublinks.length > 0 && (
                      <ul className="">
                        <li className="row row--column">
                          {route.sublinks.map((subRoute, j) => (
                            <div key={j + 's'}>
                              {this.makeLink(route, subRoute)}
                            </div>
                          ))}
                        </li>
                      </ul>
                    )}
                </div>
              ))}
          </li>
        </ul>
      </header>
    );
  }
}

Nav.defaultProps = { hideSubRoutes: false, hidden: false };
Nav.propTypes = {
  routes: PropTypes.array.isRequired,
  getPathToLink: PropTypes.func.isRequired,
  hideSubRoutes: PropTypes.bool,
  hidden: PropTypes.bool
};

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav.jsx